// extracted by mini-css-extract-plugin
module.exports = {"scrollThumb":"ScrollBar_scrollThumb__2GXMy"};